// Единый словарь, выровненный с Pilotad / Я.Директ ErirAttributes:
//   physical   — физическое лицо / самозанятый
//   individual — ИП
//   legal      — юридическое лицо
export type TinType = 'physical' | 'individual' | 'legal'

export const TIN_TYPE_LABELS: Record<TinType, { name: string; hint: string }> = {
  physical: { name: 'Физическое лицо', hint: 'самозанятый или ФИО' },
  individual: { name: 'ИП', hint: 'индивидуальный предприниматель' },
  legal: { name: 'Юридическое лицо', hint: 'ООО / АО и т.п.' },
}

export interface Requisites {
  tinType: TinType
  fullName: string
  inn: string
}

export function expectedInnLength(tinType: TinType): 10 | 12 {
  return tinType === 'legal' ? 10 : 12
}

export function validateRequisites(r: Requisites): string | null {
  if (!r.fullName.trim()) return 'Укажите ФИО или название'
  const digits = r.inn.replace(/\D/g, '')
  const need = expectedInnLength(r.tinType)
  if (digits.length !== need) {
    return `ИНН должен быть ${need} цифр`
  }
  return null
}

export async function getRequisites(channelUUID: string): Promise<Requisites | null> {
  const res = await fetch(
    `/api/max/channels/${encodeURIComponent(channelUUID)}/requisites`,
    { credentials: 'include' },
  )
  if (res.status === 404) return null
  if (!res.ok) throw new Error(`HTTP ${res.status}`)
  const text = await res.text()
  if (!text) return null
  try {
    const data = JSON.parse(text) as { tinType?: TinType; fullName?: string; inn?: string }
    if (!data.tinType || !data.fullName || !data.inn) return null
    return { tinType: data.tinType, fullName: data.fullName, inn: data.inn }
  } catch {
    return null
  }
}

export async function saveRequisites(channelUUID: string, data: Requisites): Promise<void> {
  const res = await fetch(
    `/api/max/channels/${encodeURIComponent(channelUUID)}/requisites`,
    {
      method: 'PUT',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    },
  )
  if (res.status === 204) return
  if (!res.ok) {
    let body: { error?: string; message?: string } = {}
    try {
      body = await res.json()
    } catch {}
    throw new Error(body.error || body.message || `HTTP ${res.status}`)
  }
}
